import {
  Button,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  MenuItem,
  Pagination,
  Select,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { EmptyState } from "components/EmptyState";

import { ReactComponent as AddCircle } from "assets/Svgs/AddCircle.svg";
import i18n from "i18n/i18n";
import { Link, useNavigate } from "react-router-dom";
import { useBoundStore } from "store/store";
import { useEffect, useState } from "react";
import ReportListing from "./ReportListing";
import BadgeTabs from "components/BadgeTabs";

import { orderBy as odb } from "lodash";

import { ReactComponent as FlashSvg } from "assets/Svgs/Flash.svg";
import { ReactComponent as FlashSvgWhite } from "assets/Svgs/FlashWhite.svg";

import { ReactComponent as BrokenClock } from "assets/Svgs/BrokenClock.svg";
import { ReactComponent as BrokenClockWhite } from "assets/Svgs/BrokenClockWhite.svg";
import { chunk } from "lodash";

function Reports() {
  const lang: any = useBoundStore((state: any) => state.lang);

  const [activeId, setActiveId] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [allreports, setAllReports] = useState([]);

  const navigate = useNavigate();
  const legalEntityNodeId = useBoundStore((state) => state.legalEntityNodeId);
  const getAllReportConfigurations = useBoundStore(
    (state) => state.getAllReportConfigurations
  );
  useEffect(() => {
    getAllReportConfigurations(legalEntityNodeId);
  }, []);

  const getReportConfigurations: any = useBoundStore(
    (state) => state.getReportConfigurations
  );

  const [reports, setReports] = useState([]);

  const [page, setPage] = useState(0);

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    
  };

  let paginationchunks = chunk(reports, rowsPerPage);

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage - 1);
  };

  let reportConfigTypes = ["", "time", "event"];

  const handleSetActiveId = (id: number) => {
   
    setReports(
      id === 0
        ? allreports
        : allreports.filter((report: any) => {
            return (
              report.reportconfiguration.triggertype ===  reportConfigTypes[id]
            );
          })
    );
    setActiveId(id);
  };

  useEffect(() => {
    let temp =
      getReportConfigurations.result &&
      getReportConfigurations.result[0].data.length > 0
        ? getReportConfigurations.result[0].data[0].legalentity.hasreportconfiguration.filter(
            (report: any) => {
              return report.reportconfiguration.triggertype !== "manual";
            }
          )
        : [];

      setActiveId(!getReportConfigurations.result ? -1 : 0);

    setAllReports(temp);
    setReports(temp);
  }, [ getReportConfigurations.result]);

 

  return (
    <Card className="initialCard" sx={{ padding: 0 }}>
      {activeId !== -1 || reports.length ? (
        <>
          <div
            className="reportsHeader"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div className="title" style={{ marginBottom: 0 }}>
                {i18n(lang)?.reportsTitle} ({reports.length})
              </div>
              <Link to={"/new-report"} state={{ activeId: 0 }}>
                <Button
               
                  startIcon={<AddIcon />}
                  variant="contained"
                  className="lp125"
                  sx={{
                    backgroundColor: "var(--primary-color)",
                    letterSpacing: "1.25px",
                    marginLeft: "20px",
                  }}
                >
                  {i18n(lang)?.new}
                </Button>
              </Link>
            </div>
            <div>
              <div className="customBadgeTabsWrapper">
                <BadgeTabs
                  content={[
                    {
                      id: 0,
                      text: i18n(lang).all,
                      activeIcon: "",
                      inActiveIcon: "",
                    },
                    {
                      id: 1,
                      text: i18n(lang).time,
                      inActiveIcon: <BrokenClock />,
                      activeIcon: <BrokenClockWhite />,
                    },
                    {
                      id: 2,
                      text: i18n(lang).event,
                      inActiveIcon: <FlashSvg />,
                      activeIcon: <FlashSvgWhite />,
                    },
                  ]}
                  setActiveId={handleSetActiveId}
                  activeId={activeId}
                />
              </div>
            </div>
          </div>

          <div className="reportsListingWrapper">
            {reports.length > 0
              ? reports
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: any, index: any) => {
                    return <ReportListing report={row} />;
                  })
              : ""}
          </div>

          {paginationchunks.length > 0 ? (
            <div className="DashboardTablePagination reportsHeader">
              <div>
                <Pagination
                  count={paginationchunks.length}
                  shape="rounded"
                  onChange={handleChangePage}
                  hideNextButton={page === paginationchunks.length - 1}
                  hidePrevButton={page === 0}
                />
              </div>
              <div>
                <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                  <Select
                    id="demo-simple-select-standard"
                    value={rowsPerPage}
                    onChange={handleChangeRowsPerPage}
                   
                    className="perPageSelect"
                  >
                    <MenuItem value={5}>
                      {5}
                      {i18n(lang)?.rows_per_page}
                    </MenuItem>
                    <MenuItem value={5 * 2}>
                      {5 * 2}
                      {i18n(lang)?.rows_per_page}
                    </MenuItem>
                    <MenuItem value={5 * 5}>
                      {5 * 5}
                      {i18n(lang)?.rows_per_page}
                    </MenuItem>
                    <MenuItem value={5 * 10}>
                      {5 * 10}
                      {i18n(lang)?.rows_per_page}
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
          ) : (
            ""
          )}
        </>
      ) : (
        <>
          <div
            className="reportsHeader"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div className="title">{i18n(lang)?.reportsTitle} (0)</div>
            <div className="checkbox">
              
            </div>
          </div>

          <EmptyState
            title={i18n(lang)?.reportsEmptyStateTitle}
            description={i18n(lang)?.reportsEmptystateDescription}
            icon={<AddCircle />}
            hasButton
            button={
              <div style={{ marginTop: "20px" }}>
                <Link to={"/new-report"} state={{ activeId: 0 }}>
                  <Button
                   
                    startIcon={<AddIcon />}
                    variant="contained"
                    className="lp125"
                    sx={{
                      backgroundColor: "var(--primary-color)",
                      letterSpacing: "1.25px",
                    }}
                  >
                    {i18n(lang)?.reportsEmptyStateBtn}
                  </Button>
                </Link>
              </div>
            }
          />
        </>
      )}
    </Card>
  );
}

export default Reports;
